import React, { useState, useEffect } from 'react';
import AddCommentIcon from '@mui/icons-material/AddComment';
import TimeAgo from 'react-timeago'
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import Comment from './Comment';

const Post = (props) => {
  const kilroyCookie = props.session;
  const [fetching, setFetching] = useState(false);
  const [showReplyInput, setShowReplyInput] = useState(false);
  const [comment, setComment] = useState();
  const [comments, setComments] = useState(props.data.comments);
  const [isLiking, setIsLiking] = useState(false);

  useEffect(() => {
    setIsLiking(false);
  }, [props.data]);

  const reply = async () => {
    if (!kilroyCookie) {
      alert('You do not have a valid session!');
      return;
    }
    setShowReplyInput(true);
  };

  const handleNewReply = (newComment) => {
    const oldComments = Object.assign([], comments);
    const newComments = oldComments.concat(newComment);
    setComments(newComments);
  };

  const cancelReply = () => {
    setShowReplyInput(false);
    setComment('');
  };

  const like = () => {
    setIsLiking(true);
    let likeData = {
      uri: '/likes',
      method: 'POST',
    }
    try {
      let fd = new FormData();
      fd.append('like[post_id]', props.data._id || props.data.id);
      fd.append('like[cookie]', kilroyCookie);
      likeData['body'] = fd;
      fetch(likeData.uri, likeData).then(cd => {
        cd.json().then((cj) => {
          // Now setLikes after pushing this one into the existing ones..
          // const oldLikes = Object.assign([], likes);
          // const newLikes = oldLikes.concat(cj['like']);
          // setLikes(newLikes);
          // setHasLiked(true);
          // This is a nooop here, because we get the likes off of the bus.
          console.log('Posted like...');
        });
      });
    } catch(e) {
      console.log('Error posting like: ' + e);
    }
  };

  // Organize comments into threaded structure
  const organizeThreadedComments = (comments) => {
    const threaded = [];
    const commentMap = {};

    // Create a map of all comments
    comments.forEach(comment => {
      commentMap[comment._id || comment.id] = { ...comment, replies: [] };
    });

    // Organize into parent-child relationships
    comments.forEach(comment => {
      const commentObj = commentMap[comment._id || comment.id];
      if (comment.parent_comment_id && commentMap[comment.parent_comment_id]) {
        commentMap[comment.parent_comment_id].replies.push(commentObj);
      } else {
        threaded.push(commentObj);
      }
    });

    return threaded;
  };

  const fetchPostByCookie = async () => {
    if (fetching) {
      console.log('Already fetching. Like wedge.');
      return;
    }
    if (!props.data.location) {
      console.log("No location!!!");
      return;
    }
    setFetching(true);
    let requestData = {
      uri: '/posts',
      method: 'GET'
    };
    const data = await fetch(requestData.uri + '?loc=' + props.data.location[1]
          + ',' + props.data.location[0] + '&cookie=' + kilroyCookie);
    const jd = await data.json();
    if (jd['posts'] && jd['posts'].length > 0) {
      console.log('Comment OK');
      // setCommenterPost(jd['posts'][0]);
      return true;
    } else {
      console.log('Comment NOT OK');
      return false;
    }
  };

  const submitComment = () => {
    let commentData = {
      uri: '/comments',
      method: 'POST',
    }
    try {
      let fd = new FormData();
      fd.append('comment[body]', comment);
      fd.append('comment[cookie]', kilroyCookie);
      fd.append('comment[post_id]', props.data._id || props.data.id);

      commentData['body'] = fd;
      fetch(commentData.uri, commentData).then(cd => {
        cd.json().then((cj) => {
          const oldComments = Object.assign([], comments);
          const newComments = oldComments.concat(cj['comment']);
          setComments(newComments);
          setShowReplyInput(false);
          setComment('');
        });
      });
    } catch(e) {
      console.log('Error posting comment: ' + e);
    }
  };

  const deletePost = async () => {
    if (!window.confirm('Are you sure you want to delete this post?')) {
      return;
    }

    const postId = props.data._id.$oid || props.data._id || props.data.id;
    console.log('Deleting post with ID:', postId);
    console.log('Post data:', props.data);

    if (!postId) {
      alert('Error: Post ID not found');
      return;
    }

    try {
      const response = await fetch(`/posts/${postId}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        // Call parent callback to remove post from list
        if (props.onPostDeleted) {
          props.onPostDeleted(postId);
        }
      } else {
        alert('Failed to delete post');
      }
    } catch (error) {
      console.error('Error deleting post:', error);
      alert('Error deleting post');
    }
  };

  const handleCommentInput = (d) => {
    setComment(d.target.value);
  };

  const isVidUrl = (filestr) => {
    if (filestr.indexOf('mp4') !== -1) {
      return true;
    } else if (filestr.indexOf('webm') !== -1) {
      return true;
    } else {
      return false;
    }
  };

  const isDev = () => {
    return window.location.href.indexOf('localhost') !== -1;
  };

  return (
    <div className='post'>
      <div className='post-main'>
        { (props.data.image_url && isVidUrl(props.data.image_url)) ? <video muted playsInline autoplay controls loop='true' autoPlay='autoplay' onClick={() => { props.hideTip(); props.cancelThumbnail && props.cancelThumbnail()}} alt='' className='post-image'><source src={props.data.image_url} type={isDev() ? 'video/webm' : 'video/mp4' } /></video> : <></> }
        { (props.data.image_url && !isVidUrl(props.data.image_url)) ? <img onClick={() => { props.hideTip(); props.cancelThumbnail && props.cancelThumbnail()}} alt='' src={props.data.image_url} className='post-image' /> : <></> }
        <div className='post-bottom'>
          <div className='post-bottom-left'>
            <div className='like-pill' onClick={() => like()}>
              { (props.data.likes?.filter(pl => pl.cookie === kilroyCookie.toString()).length > 0)
                  ? <FavoriteRoundedIcon style={{marginRight: '6px'}} />
                  : isLiking ? <CircularProgress style={{width: '20px', height: '20px', marginRight: '6px'}} /> :  <FavoriteBorderRoundedIcon style={{marginRight: '6px'}} /> }
              <span className='like-count'>{props.data.likes.length}</span>
            </div>
            <div className='whitecircle' style={{marginLeft: '80px', marginTop: '-44px'}} onClick={() => reply()}>
               <AddCommentIcon />
            </div>
            {props.data.cookie === kilroyCookie.toString() && (
              <div className='whitecircle' style={{marginLeft: '130px', marginTop: '-44px'}} onClick={() => deletePost()}>
                <DeleteIcon />
              </div>
            )}
          </div>
          <div className='post-bottom-right'>
            <div className='post-time-ago'>
              <TimeAgo date={props.data.created_at} />
            </div>
            { props.data.title ? <span style={{fontSize: '16px', fontWeight: 'bold'}}>{props.data.title}</span> : <></> }
          </div>
        </div>
      </div>

      <div style={{width: '95%', marginLeft: '20px', marginRight: '20px', padding: '10px'}}>
         {
            (comments && comments.length > 0) ?
               organizeThreadedComments(comments).map(comment => (
                 <Comment
                   key={comment._id || comment.id}
                   comment={comment}
                   level={0}
                   kilroyCookie={kilroyCookie}
                   onReply={handleNewReply}
                   handleThumbnailClick={props.handleThumbnailClick}
                 />
               ))
               : <></>
         }
       </div>
       { showReplyInput ?
           <div>
              <div style={{marginBottom: '10px', fontSize: '14px', color: '#ccc'}}>
                Add a comment...
              </div>
              <form onSubmit={(e) => {e.preventDefault(); submitComment(); return false;}}>
                <input className='comment-input' type='text' value={comment || ''}
                       placeholder="Write a comment..."
                       onSubmit={(e) => {e.preventDefault(); submitComment(); return false;}}
                       onChange={(d) => handleCommentInput(d)} />
                &nbsp; <div className='llbutton' onClick={() => cancelReply()}>Cancel</div>
                       onSubmit={(e) => {e.preventDefault(); submitComment(); return false;}}
                       onChange={(d) => handleCommentInput(d)} />
                &nbsp; <div className='llbutton' onClick={() => cancelReply()}>Cancel</div>
              </form>
           </div>
           :
           <></>
        }
    </div>
  );
}

export default Post;
